/* eslint-disable formatjs/no-literal-string-in-jsx */
import { BugReport } from "@mui/icons-material";
import {
  Button,
  Container,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { FormattedMessage } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
const Footer = styled("div")(({ theme }) => ({
  width: "100%",
  position: "fixed",
  bottom: 0,
}));

const FooterSubWrapper = styled("div")(({ theme }) => ({
  padding: "4px 0",
  color: "#fff",
  background: theme.palette.secondary.main,
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));

const FooterPage = () => {
  const theme = useTheme();
  const isResponsive = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <>
      <Footer sx={{ zIndex: 10000 }}>
        <FooterSubWrapper>
          <Container>
            <Stack
              direction="row"
              spacing={{ xs: 1, md: 10 }}
              justifyContent="space-between"
            >
              <Typography
                variant="subtitle1"
                component="div"
                fontWeight="bold"
                color="inherit"
              >
                &#169; Eventpxl By Sportpxl
              </Typography>
              <Button
                component={RouterLink}
                to="/legal"
                color="inherit"
                variant="text"
                sx={{
                  textDecorationColor: "white",
                  height: 20,
                  alignSelf: "center",
                  justifySelf: "center",
                }}
              >
                <FormattedMessage id="legals.title" />
              </Button>
              <Button
                sx={{
                  height: 20,
                  textDecorationColor: "white",
                  alignSelf: "center",
                  justifySelf: "center",
                }}
                variant="text"
                component={RouterLink}
                color="inherit"
                to="/terms-conditions"
              >
                CGU
              </Button>
              {!isResponsive && (
                <Typography
                  variant="caption"
                  component="div"
                  color="inherit"
                  sx={{ alignSelf: "center", justifySelf: "center" }}
                >
                  {`v${process.env.REACT_APP_VERSION}`}
                </Typography>
              )}
              {!isResponsive && (
                <Button
                  sx={{
                    height: 20,
                    alignSelf: "center",
                    justifySelf: "center",
                  }}
                  variant="text"
                  color="inherit"
                  component={RouterLink}
                  to="mailto:contact@eventpxl.com"
                  startIcon={<BugReport />}
                >
                  REPORTER UN BUG
                </Button>
              )}
            </Stack>
          </Container>
        </FooterSubWrapper>
      </Footer>
    </>
  );
};

export default FooterPage;
